import React from 'react';
import { Link } from 'react-router-dom';
import { FiCode, FiLayers, FiTrendingUp, FiPenTool } from 'react-icons/fi';
import { MdDesignServices, MdSchool } from 'react-icons/md';
import { HiOutlineDesktopComputer } from 'react-icons/hi';
import '../../styles/Servicesagain.css';

const ServicesHome = () => {
  const serviceCategories = [
    {
      id: 'website-development',
      title: 'Website & Application Development',
      icon: <FiCode />,
      color: '#8b5cf6',
      description: 'Custom digital solutions for web and mobile',
      route: '/services/website-development'
    },
    {
      id: 'edu-tech',
      title: 'Edu Tech',
      icon: <MdSchool />,
      color: '#0ea5e9',
      description: 'Educational technology solutions',
      route: '/services/edu-tech'
    },
    {
      id: 'hr-consultancy',
      title: 'HR Consultancy',
      icon: <FiLayers />,
      color: '#f59e0b',
      description: 'Human resources solutions',
      route: '/services/hr-consultancy'
    },
    {
      id: 'digital-marketing',
      title: 'Digital Marketing',
      icon: <FiTrendingUp />,
      color: '#10b981',
      description: 'Online marketing services',
      route: '/services/digital-marketing'
    },
    {
      id: 'graphic-designing',
      title: 'Graphic Designing & Logo Services',
      icon: <FiPenTool />,
      color: '#ec4899',
      description: 'Creative design solutions',
      route: '/services/graphic-designing'
    },
    {
      id: 'trademark-copyright',
      title: 'Trademark & Copyright Services',
      icon: <MdDesignServices />,
      color: '#6366f1',
      description: 'Intellectual property protection',
      route: '/services/trademark-copyright'
    },
    {
      id: 'local-advertisement',
      title: 'Local Advertisement Services',
      icon: <HiOutlineDesktopComputer />,
      color: '#f97316',
      description: 'Local business promotion',
      route: '/services/local-advertisement'
    }
  ];

  return (
    <div className="services-home19">
      {/* Hero Section */}
      <div className="services-hero19">
        <div className="services-hero-content19">
          <h1>Our Services</h1>
          <p className="services-subtitle19">
            Comprehensive digital solutions tailored to your business needs
          </p>
          <p className="services-description19">
            We provide end-to-end services from development to marketing, 
            ensuring your digital presence is strong, effective, and results-driven.
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <div className="services-grid-container19">
        <div className="services-grid19">
          {serviceCategories.map((service, index) => (
            <Link 
              to={service.route} 
              key={index}
              className="service-card-link19"
            >
              <div className="service-card19">
                <div className="service-card-header19">
                  <div 
                    className="service-icon"
                    style={{ backgroundColor: `${service.color}20`, color: service.color }}
                  >
                    <span className="icon-emoji19">{service.icon}</span>
                  </div>
                  <h3>{service.title}</h3>
                </div>
                <p className="service-card-description19">{service.description}</p>
                <div className="service-card-footer19">
                  <span className="service-link19">
                    Explore Services
                    <span className="arrow19">→</span>
                  </span>
                </div>
                <div 
                  className="service-card-hover19"
                  style={{ backgroundColor: `${service.color}10` }}
                ></div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Process Section */}
      <div className="services-process19">
        <h2>Our Service Process</h2>
        <div className="process-steps19">
          <div className="process-step19">
            <div className="step-number19">1</div>
            <h4>Consultation</h4>
            <p>Understand your requirements and goals</p>
          </div>
          <div className="process-step19">
            <div className="step-number19">2</div>
            <h4>Planning</h4>
            <p>Create a detailed strategy and roadmap</p>
          </div>
          <div className="process-step19">
            <div className="step-number19">3</div>
            <h4>Execution</h4>
            <p>Implement the solution with quality standards</p>
          </div>
          <div className="process-step19">
            <div className="step-number19">4</div>
            <h4>Support</h4>
            <p>Provide ongoing maintenance and updates</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesHome;